"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ValidationTooltip = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactUiTheming = require("@concur/react-ui-theming");
var _react = _interopRequireWildcard(require("react"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _Icon = require("../Icon/Icon");
var _Popper = require("../utils/_Popper");
var _useUniqueId = require("../utils/useUniqueId");
var _constants = require("../utils/constants");
var _ValidationTooltip = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./ValidationTooltip.css") : void 0);
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
// This linting rule is disabled due to the blur/focus events being present
// inside of the form control which consumes this validation tooltip.

/* eslint-disable jsx-a11y/no-static-element-interactions */
// This linting rule is disabled due to custom handling of focus elements. Since we
// custom handle focus of the tooltip, we choose to use an <i> tag to anchor the element
// as we control the show/hide of the ValidationTooltip from the focus/blur of the associated
// form control

var CSS_BLOCK = 'sapcnqr-validation-tooltip';
var VALIDATION_TOOLTIP_ICON_SIZE_MAP = {
  lg: 'sm',
  md: 'sm-minus'
};
var ValidationTooltip = exports.ValidationTooltip = function ValidationTooltip(_props) {
  var _context, _context2, _context3, _context4;
  var addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  var props = addChildProps ? _objectSpread(_objectSpread({}, _props), addChildProps(ValidationTooltip, _props)) : _props;
  var id = props.id,
    innerContainerProps = props.innerContainerProps,
    _props$show = props.show,
    showProp = _props$show === void 0 ? false : _props$show,
    _props$size = props.size,
    size = _props$size === void 0 ? 'lg' : _props$size,
    _props$state = props.state,
    state = _props$state === void 0 ? 'error' : _props$state,
    targetClassName = props.targetClassName,
    text = props.text;
  var _useState = (0, _react.useState)(showProp),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var tooltipId = (0, _useUniqueId.useUniqueId)();
  if (id) {
    tooltipId = id;
  }
  (0, _react.useEffect)(function () {
    setShow(showProp);
  }, [showProp]);
  var handleMouseLeave = function handleMouseLeave() {
    setShow(false);
  };
  var handleMouseEnter = function handleMouseEnter() {
    setShow(true);
  };
  var themeProviderContext = (0, _react.useContext)(_reactUiTheming.ThemeProviderContext);
  var _ref = themeProviderContext || {},
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'concur_default' : _ref$theme;
  if (theme.indexOf('_ios') >= 0 || theme.indexOf('_android') >= 0) {
    return null;
  }
  var classnames = _bind.default.bind(_ValidationTooltip.default);
  var tooltipClasses = classnames(CSS_BLOCK, (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "--in"), show));
  var targetClasses = classnames("".concat(CSS_BLOCK, "__target"), targetClassName);
  var arrowClasses = classnames("".concat(CSS_BLOCK, "__arrow"), (0, _concat.default)(_context = "".concat(CSS_BLOCK, "__arrow--")).call(_context, size), (0, _concat.default)(_context2 = "".concat(CSS_BLOCK, "__arrow--")).call(_context2, state));
  var innerClasses = classnames("".concat(CSS_BLOCK, "__inner"), (0, _concat.default)(_context3 = "".concat(CSS_BLOCK, "__inner--")).call(_context3, size), (0, _concat.default)(_context4 = "".concat(CSS_BLOCK, "__inner--")).call(_context4, state), innerContainerProps === null || innerContainerProps === void 0 ? void 0 : innerContainerProps.className);
  return /*#__PURE__*/_react.default.createElement(_Popper.Popper, {
    arrowClassName: arrowClasses,
    disableEdgeDetection: true,
    popperClassName: tooltipClasses,
    popperPlacement: "top-start",
    popperProps: {
      'aria-live': 'polite',
      id: tooltipId,
      role: 'tooltip'
    },
    show: show,
    showArrow: true,
    targetClassName: targetClasses,
    targetComponent: /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
      ariaLabel: text,
      iconName: "messaging-".concat(state),
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      tabIndex: 0,
      onFocus: function onFocus() {
        return setShow(true);
      },
      onBlur: function onBlur() {
        return setShow(false);
      },
      size: VALIDATION_TOOLTIP_ICON_SIZE_MAP[size]
    })
  }, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, innerContainerProps, {
    className: innerClasses
  }), text));
};
ValidationTooltip.displayName = 'ValidationTooltip';
ValidationTooltip.propTypes = {
  text: _propTypes.default.string.isRequired,
  id: _propTypes.default.string,
  innerContainerProps: _propTypes.default.object,
  show: _propTypes.default.bool,
  size: _propTypes.default.oneOf(_constants.CONTROL_SIZES),
  state: _propTypes.default.oneOf(_constants.FORM_CONTROL_VALIDATION_STATES),
  targetClassName: _propTypes.default.string
};
var _default = exports.default = ValidationTooltip;